import { parseApiError } from "@/lib/api/api-error";
import { isValidEmail } from "@/lib/api/login-form";

export interface ForgotPasswordFormValues {
  email: string;
}

export function isForgotPasswordFormValid(form: ForgotPasswordFormValues): boolean {
  return isValidEmail(form.email.trim());
}

export function toForgotPasswordRequest(form: ForgotPasswordFormValues) {
  return {
    email: form.email.trim(),
  };
}

const FORGOT_PASSWORD_MESSAGES = {
  network:
    "We couldn't reach the server. Check your connection and try again.",
  validation: "Please enter a valid email address.",
  generic: "Something went wrong. Please try again later.",
} as const;

export function getForgotPasswordErrorMessage(err: unknown): string {
  const { status, isNetworkError } = parseApiError(err);

  if (isNetworkError) {
    return FORGOT_PASSWORD_MESSAGES.network;
  }

  if (status === 400) {
    return FORGOT_PASSWORD_MESSAGES.validation;
  }

  return FORGOT_PASSWORD_MESSAGES.generic;
}

export const FORGOT_PASSWORD_SUCCESS_MESSAGE =
  "If an account exists for that email, we sent password reset instructions.";

export function getForgotPasswordSuccessMessage(response?: {
  message?: string;
}): string {
  return response?.message?.trim() || FORGOT_PASSWORD_SUCCESS_MESSAGE;
}
